import { Component, OnInit, ViewChild } from "@angular/core";
import { RequestModel } from "../../Shared/Models/app.MasterRequestModel";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { DialogService } from "../../Shared/dialog.service";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { EncrDecrService } from "src/app/AuthGuard/EncrDecrService";
declare var $: any;
import { QuickLoanService } from "src/app/_QuickLoan/services/quickLoan.service";

import { LmsService } from "../../_Lms/services/lms.service";
@Component({
    selector: 'app-noc-checking-master',
    templateUrl: './noc-checking-master.component.html',
    styleUrls: ['./noc-checking-master.component.scss'],
    standalone: false
})
export class NocCheckingMasterComponent implements OnInit {
  private _MasterService; 
    data: any;
      dialogreturn: any;
  showSpinner: boolean = false;
  loading: boolean = false;
    ProductId: any = 0;
      FilterProductId: any = "";
  ProcessDropdown: any = [];
   SelectProductCategory: any = "";
  ProductName: string = "";
  ProductShortName: string = "";
  ProductCategoryDropdown: any = [];
   IsUpdate: boolean = false;
  IsEdit: boolean = false;
  IsDisabled: boolean = false;
  IsDisabledAccount: boolean = false;
  resNames: any;
  dataSource: any;
  name: any;
  displayedColumns: string[] = ['Id', 'Name','EditAction'];

   configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(private dataSharingService: DataSharingService,
      private route: ActivatedRoute,
      private dialog: DialogService,
      private _EncrDecrService: EncrDecrService,
      public snackBar: MatSnackBar,
      private MasterService: MasterService,
      private lmsService: LmsService,
      private _QuickLoanService: QuickLoanService) { 
        this._MasterService = MasterService;
      }

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("NOC NAMES");
    this.data = JSON.parse(sessionStorage.getItem("currentUser"));
    this.route.paramMap.subscribe((param: ParamMap) => {
      this.FilterProductId = this._EncrDecrService.decrypt(
        decodeURIComponent(param.get("Id"))
      );
            this.getProductDetail();

      // if (this.ProductId) {
      //   this.QuickLoan_Get_ProcessLevel();
      // }
    });
    this.getNocNames();
  }
  getProductDetail() {
    this._MasterService.GetProductListById({ ProductId: this.FilterProductId }).subscribe((result) => {
      if (result.length > 0) {
        this.SelectProductCategory = result[0].ProductCatId;
        this.ProductName = result[0].Product;
        this.ProductShortName = result[0].ShortName;
      }
    });
  }

  // getNocNames(){
  //   this._MasterService.Get_Noc_Matser()
  //   .subscribe((res)) => {

  //   }
  // }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  getNocNames(){
  this.showSpinner = true;
    this._MasterService.Get_Noc_Matser({ ProductId: this.FilterProductId }).subscribe({
      next: (result: any) => {
        this.resNames = result || [];
        this.dataSource = new MatTableDataSource(this.resNames);
        this.showSpinner = false;
        console.log("abc", result);
      },
      error: () => {
        this.showSpinner = false;
      },
    });
  }
  onAddLoanSeries() {
    // this.loanSeriesModal = { Loan_SeriesId: 0, Loan_Accounting_CatId: "", Loan_Products: [], LoginUserId: this.data.userId };
    $('#AddLSModal').modal('show');
    $("#AddLSModal").css("z-index", "1050");
  }
  // onSaveNOCName() {
  //   this._MasterService.Save_Noc_Matser({
  //     ID: 0,
  //     ProductId: this.FilterProductId,
  //     Name: this.name,
  //     Is_Active: 1
  //   }).subscribe((res)) => {
  //     if (res[0].CODE >= 0) {
  //           this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
  //           this.getLoanSeriesList();
  //         } else {
  //           this.snackBar.openFromComponent(SnackbarComponent, { data: res[0].MSG, ...this.configSuccess });
  //         }
  //   }
  // }

  onSaveNOCNames() {

    const payload =  {
      ID: 0,
      ProductId: this.FilterProductId,
      Name: this.name,
      Is_Active: 1
    }
    this.MasterService.Save_Noc_Matser(payload)
    .subscribe((response) => {
        if (response[0].CODE >= 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });
            this.showSpinner = false;
            this.OnClose();

      this.getNocNames();
    } 
    else
      {
        this.snackBar.openFromComponent(SnackbarComponent, {
            data: response[0].MSG,
            ...this.configSuccess,
          });}
    
  });
  }
  OnClose() {
    $('#AddLSModal').modal('hide');
    // this.loanSeriesModal={};
  }

  // OnDeleteSeries(Id: any) {
  //   this.dialog
  //     .confirmDialog({
  //       title: "Confirm Delete",
  //       message: "Are you sure you want to delete this NOC Name?",
  //       confirmText: "Yes",
  //       cancelText: "No",
  //     })
  //     .afterClosed()
  //     .subscribe((confirmed) => {
  //       if (confirmed) {
  //         this._MasterService.Delete_Noc_Matser({ ID: Id }).subscribe((res) => {
  //           if (res[0].CODE >= 0) {
  //             this.snackBar.openFromComponent(SnackbarComponent, {
  //               data: res[0].MSG,
  //               ...this.configSuccess,
  //             });
  //             this.getNocNames();
  //           } else {
  //             this.snackBar.openFromComponent(SnackbarComponent, {
  //               data: res[0].MSG,
  //               ...this.configSuccess,
  //             });
  //           }
  //         });
  //       }
  //     });
  // }

  OnDeleteSeries(row: any) {
    this.dialogreturn = this.dialog.openConfirmDialog('Are you sure you want to delete?');
    this.dialogreturn.afterClosed().subscribe(dialogResult => {
      if (dialogResult == true) {
        this._MasterService.Delete_Noc_Matser({ ID: row.ID }).subscribe((response) => {
          if (response[0].CODE >= 0) {
            this.snackBar.openFromComponent(SnackbarComponent, { data: response[0].MSG, ...this.configSuccess });
            this.getNocNames();
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, { data: response[0].MSG, ...this.configSuccess });
          }
        });
      }
    });
  }

}
